export const CORE_SERVICE_IDS220 = ['mrm', 'lidia', 'bookquest', 'nexmap'] as const;
export type CoreServiceId220 = (typeof CORE_SERVICE_IDS220)[number];

export const CORE_CONSENT_SCOPES220 = [
  'service.use',
  'guardian.supervision',
  'organization.participation',
  'data.processing',
  'crossService.growthRecord',
  'marketing.receive',
] as const;
export type CoreConsentScope220 = (typeof CORE_CONSENT_SCOPES220)[number];

export const coreServiceLabels220: Record<CoreServiceId220, string> = {
  mrm: 'MY real Money',
  lidia: 'LIDIA',
  bookquest: 'BookQuest',
  nexmap: 'NEXMAP',
};

export const coreConsentLabels220: Record<CoreConsentScope220, string> = {
  'service.use': '서비스 이용',
  'guardian.supervision': '보호자 동의',
  'organization.participation': '기관 참여',
  'data.processing': '데이터 활용 범위',
  'crossService.growthRecord': '서비스 간 학습기록 연계',
  'marketing.receive': '마케팅 수신',
};

export const coreActivityLabels220: Record<string, string> = {
  'article.read': '경제기사 읽기',
  'quiz.complete': '퀴즈 완료',
  'mission.complete': '생활 미션',
  'family.talk': '가족 대화',
  'puzzle.piece': '퍼즐 조각',
  'igloo.stage': '이글루 단계 상승',
};

export const coreRewardLabels220: Record<string, string> = {
  points: '포인트',
  ice_brick: '얼음 벽돌',
  puzzle_piece: '퍼즐 조각',
  special_brick: '특별 벽돌',
};

export interface CoreLearningEvent220 {
  eventId: string;
  serviceId: CoreServiceId220;
  activityType: string;
  contentId: string;
  result: string;
  occurredAt: string;
  demoMode: boolean;
}

export interface CoreLedgerEntry220 {
  entryId: string;
  serviceId: CoreServiceId220;
  reason: string;
  rewardCode: string;
  quantity: number;
  idempotencyKey: string;
  demoMode: boolean;
}

export interface CoreServiceLink220 {
  serviceId: CoreServiceId220;
  linked: boolean;
  adapterConnected: boolean;
}

/** Demo activity is recorded but is never part of a growth total. */
export function growthEvents220(events: CoreLearningEvent220[]): CoreLearningEvent220[] {
  return events.filter((event) => !event.demoMode);
}

export function activityCounts220(events: CoreLearningEvent220[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const event of growthEvents220(events)) counts[event.activityType] = (counts[event.activityType] ?? 0) + 1;
  return counts;
}

/**
 * Totals are always read for one service. There is deliberately no helper that
 * adds up two services: NEXPA does not exchange MRM bricks for another
 * service's points, and a combined total is the first step toward that.
 */
export function rewardTotalsForService220(entries: CoreLedgerEntry220[], serviceId: CoreServiceId220): Record<string, number> {
  const totals: Record<string, number> = {};
  for (const entry of entries) {
    if (entry.serviceId !== serviceId || entry.demoMode) continue;
    totals[entry.rewardCode] = (totals[entry.rewardCode] ?? 0) + entry.quantity;
  }
  return totals;
}

/** Using a service is not by itself permission to share growth records. */
export function canShareAcrossServices220(consents: Partial<Record<CoreConsentScope220, boolean>>): boolean {
  return Boolean(consents['crossService.growthRecord']);
}

export function connectedServices220(links: CoreServiceLink220[]): CoreServiceLink220[] {
  return links.filter((link) => link.adapterConnected);
}
